import { FC } from 'react'
import { ButtonLink } from './ui/ButtonLink'
import { eventsData } from '../data'
import { isMarketplaceEnabled } from '../app/featureFlags'
import { isEventPast } from '../views/Events'

/** Where the CTAs render: over the top banner (sm and up) or stacked in the page (mobile only). */
type HomeCtasPlacement = 'overlay' | 'inline'

const containerClasses: Record<HomeCtasPlacement, string> = {
  overlay:
    'absolute inset-x-0 bottom-0 top-[72%] hidden items-center justify-center gap-8 px-4 sm:flex lg:gap-12',
  inline: 'flex w-full flex-col gap-4 sm:hidden',
}

const ctaClasses: Record<HomeCtasPlacement, string> = {
  overlay: [
    'justify-center whitespace-nowrap px-6 py-3 text-base',
    'shadow-[0_10px_24px_rgba(0,0,0,0.9),0_4px_8px_rgba(0,0,0,0.7)] ring-1 ring-black/40',
    'lg:px-14 lg:py-6 lg:text-2xl',
  ].join(' '),
  inline: 'w-full justify-center text-2xl',
}

/** Home page call-to-action buttons. */
export const HomeCtas: FC<{ placement: HomeCtasPlacement }> = ({ placement }) => {
  const marketplaceEnabled = isMarketplaceEnabled()
  const upcomingEvent = eventsData.events.find((e) => !isEventPast(e.date))

  if (!upcomingEvent && !marketplaceEnabled) return null

  return (
    <div className={containerClasses[placement]}>
      {upcomingEvent && (
        <ButtonLink
          href={upcomingEvent.ticketLink}
          rel='noreferrer'
          target='_blank'
          variant='secondary'
          size='md'
          className={ctaClasses[placement]}
        >
          Buy Tickets
        </ButtonLink>
      )}
      {marketplaceEnabled && (
        <ButtonLink to='/merch' variant='primary' size='md' className={ctaClasses[placement]}>
          Shop Merch
        </ButtonLink>
      )}
    </div>
  )
}
